import z from "zod";

// BlobStorage tracks the location of an asset on blob storage
const BlobStorageSchema = z.object({
  bucket: z.string(),
  key: z.string(),
});

// PublicAsset provides metadata about a public asset that was generated
export const PublicAssetSchema = z.object({
  id: z.string(),
  blockId: z.string().optional(),
  chatId: z.string().optional(),
  blob: BlobStorageSchema,
  tenantId: z.string(),
  organizationId: z.string(),
  workspaceId: z.string(),
  projectId: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  modifiedBy: z.string(),
  modifiedAt: z.string(),
  isArchived: z.boolean(),
});

// Params for getting a public asset by block ID
export const BlockIdParamsSchema = z.object({
  blockId: z.string(),
});

// Request body for creating a public asset
export const CreatePublicAssetRequestSchema = z.object({
  markdown: z.string(),
  blockId: z.string().optional(),
  chatId: z.string().optional(),
});
